var _excluded = ["space", "as"],
  _excluded2 = ["children", "space"];
var _templateObject, _templateObject2, _templateObject3;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import React, { Children } from "react";
import flattenChildren from "react-keyed-flatten-children";
import styled, { css } from "styled-components";
import { map } from "../breakpoint";
import { p, m, mt } from "../spacing";
import { isList, isValidSpacing, spacingPropTypeMap } from "../utils"; // eslint-disable-next-line @typescript-eslint/no-unused-vars
var StackWrapper = styled(function (_ref) {
  var space = _ref.space,
    as = _ref.as,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", rest);
}).attrs({
  "data-mesh-component": "STACK"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  // If stack is set to be a ul or ol we need to reset the default styling\n\n  ", "\n\n  > * {\n    &:not(:first-child) {\n      ", ";\n    }\n  }\n"])), function (_ref2) {
  var as = _ref2.as;
  return as && isList(as) && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", ";\n      ", ";\n      list-style-type: none;\n    "])), m(0), p(0));
}, function (_ref3) {
  var space = _ref3.space;
  return map(space, function (val) {
    return isValidSpacing(val) && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n              ", ";\n            "])), mt(val));
  });
});
export var Stack = function Stack(props) {
  var children = props.children,
    _props$space = props.space,
    space = _props$space === void 0 ? 0 : _props$space,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var ChildComponent = isList(props.as) ? "li" : "div";
  return /*#__PURE__*/React.createElement(StackWrapper, _extends({
    space: space
  }, otherProps), Children.map(flattenChildren(children), function (child) {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.createElement(ChildComponent, null, child);
    }
    return null;
  }));
};
Stack.displayName = "Stack";